import { css } from '@emotion/core';
import {
  Link,
  minimumWidth,
  pxToRem,
  styled,
  textStyle,
} from '@feast-it/ui/light';

export const Container = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: ${theme.spacing[2]};
    margin-bottom: ${theme.spacing[4]};

    ${minimumWidth(theme.breakpoints.small)} {
      justify-content: flex-start;
    }
  `}
`;

export const Breadcrumb = styled.span<{ isDark?: boolean }>`
  ${({ theme, isDark }) => `
    display: flex;
    gap: ${theme.spacing[2]};
    ${textStyle(theme, 'bodyMedium', isDark ? 'white' : 'black')}
  `};
`;

export const StyledLink = styled(Link)<{
  isBold?: boolean;
  isDark?: boolean;
}>`
  ${({ theme, isBold, isDark }) => css`
    ${textStyle(
      theme,
      isBold ? 'bodyBoldMedium' : 'bodyMedium',
      isDark ? 'white' : 'black'
    )};

    &:hover {
      text-decoration: underline;
      text-underline-thickness: ${pxToRem(2)};
      text-underline-offset: ${pxToRem(2)};
      cursor: pointer;
    }

    &:focus,
    &:active {
      color: ${theme.colors.mediumBlue};
    }
  `};
`;
